<template>
    <div class="form">
        <Form ref="info" :model="info" :label-width="100" :viewonly="true">
            <div class="form-section">
                <div class="form-section-title">房源信息</div>
                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="园区/社区" prop="parkId">
                            <Select
                                v-model="info.parkId"
                                transfer
                                :disabled="true"
                            >
                                <Option
                                    v-for="item in parkList"
                                    :key="item.id"
                                    :value="item.id"
                                    >{{ item.parkName }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="楼栋号" prop="floorName">
                            <Input
                                v-model="info.floorName"
                                placeholder
                                disabled
                            >
                                <span slot="append">栋</span>
                            </Input>
                        </FormItem>
                    </Col>
                </Row>

                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="房间号" prop="houseNo">
                            <Input
                                v-model="info.houseNo"
                                placeholder="例如A-1-3"
                                disabled
                            ></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="装修格局" prop="houseType">
                            <Input v-model="info.houseType" placeholder />
                        </FormItem>
                    </Col>
                </Row>

                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="建筑面积" prop="buildArea">
                            <input-number
                                v-model="info.buildArea"
                                placeholder
                                :min="0"
                            >
                                <span slot="append">㎡</span>
                            </input-number>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="出租类型" prop="rentType">
                            <Select v-model="info.rentType" transfer>
                                <Option
                                    v-for="item in dict.rentTypeNew.toList()"
                                    :key="item.id"
                                    :value="item.id"
                                    >{{ item.text }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>

                <Row :gutter="20">
                    <Col span="12">
                        <FormItem label="租金" prop="rent">
                            <input-number
                                v-model="info.rent"
                                placeholder
                                :min="0"
                            >
                                <span slot="append">元/月</span>
                            </input-number>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="支付方式" prop="rentMode">
                            <rent-mode
                                is-verify
                                spread-out
                                :deposit-pay-method="rentMode.depositPayMethod"
                                :rent-pay-method="rentMode.rentPayMethod"
                            />
                        </FormItem>
                    </Col>
                </Row>

                <Row :gutter="20">
                    <Col span="12">
                        <FormItem prop="otherDeposit" label="其它押金">
                            <other-deposit :value="info.otherDeposit" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem prop="otherFee" label="其它费用">
                            <other-fee :value="info.otherFee" />
                        </FormItem>
                    </Col>
                </Row>
            </div>
        </Form>

        <div class="form-section-title">发布渠道</div>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
            :width="725"
        >
            <!-- 操作列 -->
            <template #actionUpdate="{ row }">
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px; color: blue"
                    :disabled="row.channelCode == 'zwcf'"
                    @click="updatePub(row)"
                >
                    更新
                </Button>
            </template>

            <template #actionPublish="{ row }">
                <Button
                    type="default"
                    size="small"
                    style="margin-right: 5px; color: blue"
                    @click="publish(row)"
                >
                    {{ row.btnName }}
                </Button>
            </template>
        </Table>
    </div>
</template>

<script>
import Dict from '_u/dict'
import { assetsParkRootList } from '@/api/configuration'
import { cent, deepCopy, yuan } from '_u/helper'
import {
  assetsHouseView,
  pubHouseToZwZhao,
  unPubHouseToZwZhao,
  updateToZwZhao,
  marketRoomCheckPublish,
  marketRoomUnPublish,
  marketRoomPublish
} from "@/api/assets";
import RentMode from '_vc/fields/rent-mode'
import RoomConfig from '_vc/fields/room-config'
import RentInterval from '_vc/fields/rent-interval'
import OtherFee from '_vc/fields/other-fee'
import OtherDeposit from '_vc/fields/other-deposit'

export default {
    components: { RentMode, OtherFee, OtherDeposit },
    inject: {
        $modal: {
            default: null,
        },
    },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data() {
        return {
            mtHeight: 139,
            loading: false,
            page: {
                total: 0,
                list: [],
                pageSize: 20,
                page: 1,
            },
            info: {
                parkId: '',
                floorName: '',
                houseNo: '',
                rentType: '', // 出租类型
                buildArea: '', // 建筑面积
                houseType: '', // 装修格局
                rent: '', // 租金
                otherFee: [], // 其它费用
                otherDeposit: [], // 其它押金
            },
            parkList: [], // 园区列表
            rentMode: '', //交租方式
            dict: {
                rentTypeNew: Dict.NULL,
            },
            isView: true,
            selection: [],
        }
    },

    computed: {
        columns() {
            return [
                {
                    key: 'channelName',
                    title: '渠道名称',
                    align: 'center',
                    width: 130,
                },
                {
                    title: '房源信息更新到渠道',
                    align: 'center',
                    width: 250,
                    slot: 'actionUpdate',
                },
                {
                    key: 'publishStatusText',
                    title: '上架状态',
                    align: 'center',
                    width: 210,
                },
                {
                    title: '上下架',
                    align: 'center',
                    width: 130,
                    slot: 'actionPublish',
                },
            ]
        },
    },
    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        const btns = []
        if (this.isView) {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '关闭',
            })
        } else {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '取消',
            })
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.fetch(),
                assetsParkRootList(),
                Dict.get(['rent_type_new']),
            ])
                .then((args) => {
                    var [view, park, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (view) {
                        var viewData = view.data.entity
                        // 实体数据

                        if (viewData.entity) {
                            viewData = viewData.entity
                        }
                        Object.keys(viewData).forEach(
                            (name) => (viewData[name] = viewData[name] || '')
                        )
                        viewData.unitPrice = viewData.unitPrice
                            ? yuan(viewData.unitPrice)
                            : 0
                        viewData.rent = viewData.rent ? yuan(viewData.rent) : 0
                        viewData.commission = viewData.commission
                            ? yuan(viewData.commission)
                            : 0
                        viewData.deposit = viewData.deposit
                            ? yuan(viewData.deposit)
                            : 0
                        viewData.minPrice = viewData.minPrice
                            ? yuan(viewData.minPrice)
                            : 0
                        viewData.maxPrice = viewData.maxPrice
                            ? yuan(viewData.maxPrice)
                            : 0

                        viewData.facilitys.forEach((v) => {
                            v.price = yuan(v.price)
                        })
                        viewData.otherFee.forEach((v) => {
                            v.amount = yuan(v.amount)
                        })
                        viewData.otherDeposit.forEach((v) => {
                            v.amount = yuan(v.amount)
                        })

                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name])
                        )

                        this.rentMode = {
                            depositPayMethod: viewData.depositPayMethod,
                            rentPayMethod: viewData.rentPayMethod,
                        }

                        this.list = viewData.children
                    }

                    this.parkList = park.data.list

                    this.buildPublishRecord(viewData)

                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    },
    methods: {
        fetch() {
            this.loading = true
            if (this.id) {
                return assetsHouseView(this.id)
            } else {
                return Promise.resolve()
            }
        },

        //更新发布数据
        updatePublishStatus(){
          assetsHouseView(this.id).then((res) =>{
              var house = res.data.entity
              this.buildPublishRecord(house)
          })
        },

        //构建发布渠道数据
        buildPublishRecord(viewData){

          var array = new Array()
          var channel = {}
          channel.channelName = '住喔出房'
          channel.channelCode = 'zwcf'
          if (viewData.publishStatus == 0) {
            channel.publishStatus = '0'
            channel.publishStatusText = '待上架'
            channel.btnName = '上架'
          } else if (viewData.publishStatus == 1) {
            channel.publishStatus = '1'
            channel.publishStatusText = '上架中'
            channel.btnName = '下架'
          }

          array.push(channel)

          var channelZhao = {}
          channelZhao.channelName = '住喔找房'
          channelZhao.channelCode = 'zwzhao'
          if (viewData.zwzhaoPublishStatus == 0) {
            channelZhao.publishStatus = '0'
            channelZhao.publishStatusText = '待上架'
            channelZhao.btnName = '上架'
          } else if (viewData.zwzhaoPublishStatus == 1) {
            channelZhao.publishStatus = '1'
            channelZhao.publishStatusText = '上架中'
            channelZhao.btnName = '下架'
          }

          array.push(channelZhao)

          this.page.list = array
        },

        updatePub(row) {
            console.log('更新操作')
          var channelCode = row.channelCode
          if (channelCode == 'zwzhao'){
            //调用接口
            var param = {'houseId':this.id}
            updateToZwZhao(param).then((res) =>{
              if (res&&res.code == '200'){
                this.$Message.success('更新成功')
              }else {
                this.$Message.err(res.msg)
              }
            })
          }else {
            this.$Message.err('暂不支持')
          }
        },

        publish(row) {
            var channelCode = row.channelCode

            if (channelCode == 'zwzhao'){
              //调用接口

              if (row.publishStatus == '0'){
                var paramPub = {'houseId':this.id}
                pubHouseToZwZhao(paramPub).then((res) =>{
                  if (res&&res.code == '200'){
                    this.$Message.success('发布成功')
                    //更新发布数据
                    this.updatePublishStatus()
                  }else {
                    this.$Message.err(res.msg)
                  }
                })
              } else if (row.publishStatus == '1'){
                var param = {'houseIds':this.id}
                unPubHouseToZwZhao(param).then((res) =>{
                  if (res&&res.code == '200'){
                    this.$Message.success('下架成功')
                    //更新发布数据
                    this.updatePublishStatus()
                  }else {
                    this.$Message.err(res.msg)
                  }
                })
              }


            }else if(channelCode == 'zwcf'){
              var publishStatus = row.publishStatus
              if (publishStatus == '1'){
                //下架
                marketRoomUnPublish(this.id).then((res) =>{
                    if (res){

                      var errors = (res.data.list || []).filter(
                        (v) => v.msg !== 'ok'
                      )

                      if (errors.length) {
                        this.$Message.error(errors[0].msg.includes('属性')? '房间信息不完整，无法发布':errors[0].msg)
                      }

                      //更新发布数据
                      this.updatePublishStatus()

                    }

                })

              }else if (publishStatus == '0'){
                //上架前校验
                marketRoomCheckPublish(this.id).then((res)=>{
                  // 校验结果处理
                  if (res) {
                    var errors = (res.data.list || []).filter(
                      (v) => v.msg !== 'ok'
                    )

                    if (errors.length) {
                      this.$Message.error(errors[0].msg.includes('属性')? '房间信息不完整，无法发布':errors[0].msg)
                    }else {
                      // 上架
                      marketRoomPublish(this.id).then((res) =>{
                        if (res&&res.code == '200'){
                          this.$Message.success('上架成功')
                        }else {
                          this.$Message.error(res.msg)
                        }
                        //更新发布数据
                        this.updatePublishStatus()
                      })
                    }
                  }

                })

              }

            }
        },
    },
}
</script>

<style lang="less" scoped>
.form {
    &-section {
        margin-bottom: 32px;

        &-title {
            font-size: 18px;
            padding-bottom: 8px;
            margin-bottom: 6px;
            border-bottom: solid 1px @c-gray-bd;
        }
    }
}
</style>
